const state = {
  map: null,
  dqType: 'AQI',
  szType: 'PH',
  dateTime: new Date()
};

const mutations = {
  SET_MAP: (state, map) => {
    state.map = map;
  },
  SET_DQ_TYPE: (state, v) => {
    state.dqType = v;
  },
  SET_SZ_TYPE: (state, v) => {
    state.szType = v;
  },
  SET_DATE_TIME: (state, v) => {
    state.dateTime = v;
  },
};

const actions = {
  setMap({
    commit
  }, map) {
    commit("SET_MAP", map);
  },
  setDqType({
    commit
  }, v) {
    commit("SET_DQ_TYPE", v);
  },
  setSzType({
    commit
  }, v) {
    commit("SET_SZ_TYPE", v);
  },
  setDateTime({
    commit
  }, v) {
    commit("SET_DATE_TIME", v);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/map.js